export default __webpack_public_path__ + "assets/images/12.a2c74e.webp";